// Base URL for API calls
const BASE_URL = "https://h-a-appliances.onrender.com";
export default BASE_URL;
